var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AuthRequests } from '@base/api/auth/auth.requests';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "../../api/auth/auth.requests";
import * as i2 from "@angular/router";
var AuthService = /** @class */ (function () {
    function AuthService(auth, router) {
        this.auth = auth;
        this.router = router;
        this._token = localStorage.getItem('eyrus-user-token') || null;
        this._refreshtoken = localStorage.getItem('eyrus-refresh-token') || null;
        this._user = JSON.parse(localStorage.getItem('eyrus-user') || '{}') || {};
        this._signUpProcess = JSON.parse(localStorage.getItem('eyrus-signProcess') || '[]') || [];
        this._accountId = localStorage.getItem('eyrus-accountId') || null;
        this._configurationKeys = JSON.parse(localStorage.getItem('eyrus-configuration-keys') || '{}') || {};
        this.currentUserSubject = new BehaviorSubject(this._user);
        this.currentContractSubject = new BehaviorSubject([]);
        this.currentPermissionsSubj = new BehaviorSubject([]);
        this.currentProjectSubject = new BehaviorSubject({});
        this.currentContract = this.currentContractSubject.asObservable().pipe(distinctUntilChanged());
        this.currentProject = this.currentProjectSubject.asObservable().pipe(distinctUntilChanged());
        this.currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());
        this.currentPermissions = this.currentPermissionsSubj.asObservable().pipe(distinctUntilChanged());
    }
    Object.defineProperty(AuthService.prototype, "token", {
        get: function () {
            return this._token;
        },
        set: function (token) {
            localStorage.setItem('eyrus-user-token', token);
            this._token = token;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "refreshToken", {
        get: function () {
            return this._refreshtoken;
        },
        set: function (token) {
            localStorage.setItem('eyrus-refresh-token', token);
            this._refreshtoken = token;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "user", {
        get: function () {
            return this._user;
        },
        set: function (user) {
            localStorage.setItem('eyrus-user', JSON.stringify(user));
            this._accountId = user.accounts ? user.accounts[0].accountId.toString() : '';
            localStorage.setItem('eyrus-accountId', this._accountId);
            this._user = user;
            this.currentUserSubject.next(user);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "accountId", {
        get: function () {
            //return this._accountId;
            var accountID = localStorage.getItem('eyrus-accountId');
            return accountID;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "signUpProcess", {
        get: function () {
            return this._signUpProcess;
        },
        set: function (step) {
            var exists = this._signUpProcess.findIndex(function (e) { return e.currentStep === step.currentStep; });
            if (exists !== -1)
                this._signUpProcess[exists] = step;
            else
                this._signUpProcess.push(step);
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.clearSignUpProcess = function () {
        this._signUpProcess = [];
    };
    Object.defineProperty(AuthService.prototype, "contract", {
        set: function (contract) {
            this.currentContractSubject.next(contract);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "project", {
        get: function () {
            return this.currentContractSubject.getValue();
        },
        set: function (project) {
            this.currentProjectSubject.next(project);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "accountPermission", {
        set: function (permissions) {
            this.currentPermissionsSubj.next(permissions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "configurationKeys", {
        get: function () {
            return this._configurationKeys;
        },
        set: function (payload) {
            localStorage.setItem('eyrus-configuration-keys', JSON.stringify(payload));
            this._configurationKeys = payload;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.switchUserAccount = function (account) {
        this._accountId = account.accountId.toString();
        localStorage.setItem('eyrus-accountId', this._accountId);
    };
    AuthService.prototype.fetchConfigKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.auth.getConfigurationKeys().toPromise()
                            .then(function (res) {
                            _this.configurationKeys = res;
                            return res;
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.logout = function () {
        localStorage.clear();
        this.user = {};
        this.token = null;
        this.refreshToken = null;
        this.currentUserSubject.next([]);
        this.currentContractSubject.next([]);
        this.currentProjectSubject.next({});
        this.currentPermissionsSubj.next([]);
        localStorage.removeItem('eyrus-show-subheader');
        this.router.navigate(['/auth/login']);
    };
    AuthService.prototype.initRefreshToken = function () {
        return this.auth.refreshToken(this.refreshToken);
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.AuthRequests), i0.inject(i2.Router)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
